import React from 'react';
import PropTypes from 'prop-types';
import Noscript from 'utils/Noscript';
import { config } from 'api';

export default function JavascriptDisabledAlert({ pageView }) {
  return (
    <Noscript className="browserWarnings stickToTop browserWarnings--disabledJs">
      <section className="browserWarnings__container">
        <div className="browserWarnings__content">
          <h2 className="browserWarnings__heading">Hello there. Please enable JavaScript.</h2>
          <p>
            We regularly develop our site to make it simpler and better. Please&nbsp;
            <a
              className="browserWarnings__link"
              href="http://www.enable-javascript.com/en"
              target="_blank"
              rel="noopener noreferrer"
            >
              enable JavaScript
            </a>
            &nbsp;in your browser to make sure you can always use our site.
          </p>
          <p>
            Why not use our award-winning&nbsp;
            <a className="browserWarnings__link" href="/webshop/getMobileApp.do">tablet and smartphone app</a>
            ?
          </p>
          {/*
            Using client side directly as it is rendered on server-side but read on
            client-side so we need client-side url
          */}
          <img
            className="u-hiddenVisually"
            src={`${config.clientApiBasePath}/wa/pv/${pageView.id}/no-js`}
            alt=""
            aria-hidden="true"
          />
        </div>
      </section>
    </Noscript>
  );
}

JavascriptDisabledAlert.propTypes = {
  pageView: PropTypes.shape({
    id: PropTypes.string,
  }),
};

JavascriptDisabledAlert.defaultProps = {
  pageView: {},
};
